<template>
  <v-container  style="height: 90vh;">
    <v-row justify="center" align="center" align-content="center" style="height: 100%;">
      <v-col cols="12" sm="4" md="3" align-self="center">
        <v-card
            :loading="loading"
            elevation="2"
            outlined
        >
          <v-col class="pa-6">
            <h2 class="mb-3">Авторизация</h2>

        <v-text-field
            v-model="login.email"
            label="Логин"
            :error-messages="error"
            required
            outlined
        ></v-text-field>
        <v-text-field
            v-model="login.password"
            label="Пароль"
            required
            type="password"
            outlined
        ></v-text-field>
        <v-btn @click="loginAction">Войти</v-btn>
          </v-col>
        </v-card>
      </v-col>

    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src

import {mapGetters} from "vuex";

export default {
  name: 'Login',
  data() {
    return {
      error: '',
      loading: false,
      login: {
        email: '',
        password: '',
        for_admin: true,
        loading: false
      },

    };
  },
  mounted() {
    // if(this.isLoggedIn){
    //   this.$router.push({ name: 'order-index' })
    // }
   // this.$store.dispatch('logout');
  },
  computed: {
    ...mapGetters({
      isLoggedIn : 'isLoggedIn',
      user: 'user'
    }),
  },
  components: {

  },
  methods: {
    loginAction: function () {
      this.loading = true
      this.error = ''
      let _this = this;
      this.$store.dispatch('login', this.login)
          .then(function (resp) {
            _this.$router.push({ name: 'order-index' })
            _this.loading = false
          })
          .catch(function (err) {
            _this.error = 'Пользователь не найден'
            //_this.$refs.form.setErrors(err.response.data);
            _this.loading = false
          }).finally(() => {
          _this.loading = false

      })
    },
  }

}
</script>
